import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchPageComponent } from './views/search-page/search-page.component';
import { SearchResultsComponent } from './views/search-results/search-results.component';

const routes: Routes = [
  { path: '', component: SearchPageComponent },
  { path: 'search-results', component: SearchResultsComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
